<template>
    <div class="torreairea_torre custom__filters-apartments">
        <!--  <div class="line__vertical-mains"></div> -->
        <button-back  class="custom__filters-torres-back" />
        <div class="custom__filters-torres" style="">
            <Availables v-if="this.totAvailables" class="availables-desk availables-torreairea custom__filters-torres-filter" :desarrollo="desarrollo"
                :filterPrice="rangeFilterPriceT11" :filterPriceDtos="rangeFilterPricesT11" :type="type"
                :existFilter="existFilter" @onUpdateModel="updateActiveModel" @defaultDetail="hideDetail"
            />
        </div>
       
        <Availables v-if="this.totAvailables" class="availables-mobile torreairea" :desarrollo="desarrollo" :filterPrice="rangeFilterPriceT11"
            :filterPriceDtos="rangeFilterPricesT11" :type="type" :existFilter="existFilter"
            @onUpdateModel="updateActiveModel"  @defaultDetail="hideDetail"/>

        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box torreairea">
                <h1 class="caption__select">
                    <span>{{ img.name }}</span>
                    <!-- <span>Seleccione un nivel, clic para ver detalles</span> -->
                </h1>
                <map-highlight-deptos :defaultActive="detail" :indicators="indicators" @activeDetail="showDetail" :torreLevel="levelTorre"
                    :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />

                <!-- <Button :img="img" :id="id" :desarrollo="desarrollo" :nivel="nivel"  :levelId="levelId" :url="url"/>-->
                <div class="line_horizontal"></div>


            </div>
            <div class="select__box torrea">
                <div v-if="!detail">
                    <h1 class="caption__select torrea">
                        <span>Seleccione un nivel, clic para ver detalles</span>
                    </h1>
                </div>
                <div  v-if="detail">
                    <Piso />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlightDeptos from "../../core/rediseno/MapHighlightDeptosAirea.vue";
import ButtonBack from "../../core/ButtonBack";
//import Button from "../../../core/Button.vue";
import Availables from "../../core/rediseno/Availables.vue";
import Piso from "./Piso.vue"


export default {
    name: "Main",
    components: {
        MapHighlightDeptos,
        //Button,
        ButtonBack,
        Availables,
        Piso
    },
    data() {
        return {
            id: this.$route.params.id,
            levelId: 0,
            //this add
            levelTorre: 48,
            //normal
            type: "departamentos",
            desarrollo: "torreaireaplus",
            arrFilteredLocations: [],
            nivel: "towerStageLevel",
            url: `cve_torre_etapa=${this.$route.params.id}`,
            torres: {
                TORRE11: {
                    name: 'TORRE 11',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torreaireaplus/Airea_+Fachada_2023.jpg',
                    width: '1000',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '563',
                    transform: '',
                    viewBox: '0 0 1000 563'
                },
                TORRE12: {
                    name: 'TORRE 12',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torreaireaplus/Airea_Fachada_Acceso+N4.jpg',
                    width: '1000',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '563',
                    transform: '',
                    viewBox: '0 0 1000 563'
                }
            },
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            activeModel: "",
            rangeFilterPriceT11: [3900000, 4995000],
            rangeFilterPricesT11: {
                /* 'NIVEL 1': [4071490.5], */
                'NIVEL 2': [3900000],
                'NIVEL 3': [4250000,4995000],
                /* 'NIVEL 4': [4233180, 3609648], */
                'NIVEL 5': [4050000],
                /* 'NIVEL 6': [3536148, 3674853], */
                'NIVEL 7': [4200000],
                'NIVEL 8': [4300000],
                /* 'NIVEL 9': [3694593], */
                'NIVEL 10': [4450000],
                /* 'NIVEL 11':[3456540,3728235],
                'NIVEL 12':[2767920,3559860],
                'NIVEL 13':[3636540,3917235], */
            },
            //add
            detail: false,
            indicators: [
                { id: 113, text: '1', transform: 'matrix(1 0 0 1 220 486)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 0, y1: 0, x2: 0, y2: 0, status: true },
                { id: 114, text: '2', transform: 'matrix(1 0 0 1 220 455)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 236, y1: 456.62, x2: 318, y2: 456.62, status: true },
                { id: 115, text: '3', transform: 'matrix(1 0 0 1 220 425)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 236, y1: 426.62, x2: 318, y2: 426.62, status: true },
                { id: 116, text: '4', transform: 'matrix(1 0 0 1 220 395)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 236, y1: 396.62, x2: 318, y2: 396.62, status: true },
                { id: 117, text: '5', transform: 'matrix(1 0 0 1 220 365)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 236, y1: 366.62, x2: 318, y2: 366.62, status: true },
                { id: 118, text: '6', transform: 'matrix(1 0 0 1 220 335)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 236, y1: 336.62, x2: 318, y2: 336.62, status: true },
                { id: 119, text: '7', transform: 'matrix(1 0 0 1 220 305)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 236, y1: 306.62, x2: 318, y2: 306.62, status: true },
                { id: 120, text: '8', transform: 'matrix(1 0 0 1 220 275)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 236, y1: 276.62, x2: 318, y2: 276.62, status: true },
                { id: 121, text: '9', transform: 'matrix(1 0 0 1 220 245)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 236, y1: 246.62, x2: 318, y2: 246.62, status: true },
                { id: 121, text: '10', transform: 'matrix(1 0 0 1 210 215)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 236, y1: 216.62, x2: 318, y2: 216.62, status: true },
                { id: 122, text: '11', transform: 'matrix(1 0 0 1 210 185)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 236, y1: 186.62, x2: 318, y2: 186.62, status: true },
                { id: 123, text: '12', transform: 'matrix(1 0 0 1 210 155)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 236, y1: 156.62, x2: 318, y2: 156.62, status: true },
                { id: 124, text: '13', transform: 'matrix(1 0 0 1 210 125)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 236, y1: 126.62, x2: 318, y2: 126.62, status: true },
            ],
            totAvailables: 0
        };
    },
    computed: {
        ...mapGetters({
            locations: "getLocations",
            filterModelos: "getStatusFilterModelos",
            selected: 'getSelectedLocation'
        }),
        development() {
            return { id: this.id, level: this.levelId };
        },
        img() {
            const torre = this.$route.params.torre;
            const torreSeleccionada = this.torres[torre];
            return torreSeleccionada;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        existFilter() {
            return this.locations
        },
    },
    methods: {
        ...mapActions(["getTowerStageLevels", "clearCoords", "getFilterModelos", "clearLevels", "clearDpt"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        updateActiveModel(model) {
            this.getFilterModelos(model);
        },
        showDetail() {
            this.detail = true;
        },
        async hideDetail() {
            // console.log("submain")
           
            /* console.log(this.existFilter) */
            this.getTowerStageLevels(this.development);
            this.detail = false;
        },
    },
    async created() {
      await this.getTowerStageLevels(this.development);
      this.getFilterModelos(this.existFilter)
      this.totAvailables = this.locations.reduce((total, ele) => {
        return total + ele.available;
      }, 0);
      
    },
    async beforeDestroy() {
        await this.clearCoords();
        await this.clearDpt();
    },
};
</script>
<style>
.availables-torreairea .availables__deptos-box {
    display: flex;
    width: 96% !important;
    padding-bottom: 20px;
    margin-top: -20px;
}

.availables-torreairea .availables__casas-box {
    display: flex;
    width: 96% !important;
    padding-bottom: 20px;
    margin-top: -20px;
}
.torreairea .availables-torreairea{
    display: flex;
    width: 100% !important;
    padding-bottom: 20px;
    margin-top: -20px;
}
.torreairea_torre .custom__apartments-filter-custom{
    display: none;
}
/* custom__apartments-filter-default custom__apartments-filter-custom */
.custom__filters-apartments .custom__apartments-filter-default{
    display: none;
}
.custom__filters-apartments .custom__apartments-filter-custom{
    display: initial;
}
.torreairea .availables__deptos-box {
    width: 100% !important;
}

.torreairea .availables__casas-box {
    width: 100% !important;
}

.torreairea_torre {
    position: relative;
}

@media (min-width:1201px) {
    .select__box.torrea {
        width: 30%;
    }

    .caption__select.torrea {
        margin-top: 30%;
    }

    .maphighlight__box.torreairea {
        border-right: 1px solid black;
    }
}

@media(max-width:1200px) {
    .torreairea_torre .map_filter {
        flex-direction: column;
    }
}</style>
